import { createRouter, createWebHashHistory } from 'vue-router'

const routerHistory = createWebHashHistory() // 引入路由模式 History

const indexRouter = {
  history: routerHistory,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/homePage.vue')
    },
    {
      path: '/solutePage',
      name: 'solutePage',
      component: () => import('../views/solutePage.vue')
    },
    {
      path: '/soluteDetail',
      name: 'soluteDetail',
      component: () => import('../views/soluteDetail.vue')
    },
    {
      path: '/companyView',
      name: 'companyView',
      component: () => import('../views/companyView.vue')
    },
    {
      path: '/productService',
      name: 'productService',
      component: () => import('../views/productService.vue')
    },
    {
      path: '/productDetailSec',
      name: 'productDetailSec',
      component: () => import('../views/productDetailSec.vue')
    }
  ]
}
const route = createRouter(indexRouter)
route.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
export default route
